let data = document.body.dataset.railse_data;

export const railsData = Object.freeze(JSON.parse(data));
